import { Component, Input, OnInit } from "@angular/core";
import { PacketService } from "@tylertech/packets-module";
import { ProcessViewModel } from "@tylertech/tyler-api-types";

@Component({
    selector: "processes-component",
    templateUrl: "./processes.tmpl.html",
    styleUrls: [
        "./processes.component.scss"
    ],
    standalone: false
})
export class ProcessesComponent implements OnInit
{
    @Input()
    enableLink: boolean;

    loading: boolean = true;

    list: ProcessViewModel[];

    constructor(
        private $packetService: PacketService
    ) { }

    ngOnInit(): void
    {
        this.$packetService.GetDashboardProcesses()
            .then((list: ProcessViewModel[]) =>
            {
                this.list = list;
            })
            .finally(() =>
            {
                this.loading = false;
            });
    }

    get hasData(): boolean
    {
        return this.list?.length > 0;
    }
}
